/**
 * Props for the Zoom slot component.
 * @public
 */
export interface TimeseriesZoomSlotProps {
  /**
   * Whether the zoom is disabled.
   */
  disabled?: boolean;
}

/**
 * Zoom slot component.
 */
export const Zoom = (props: TimeseriesZoomSlotProps) => null;

Zoom['displayName'] = 'TimeseriesChart.Zoom';
